/*
 * @Author: Ryan
 * @Date: 2025-12-26
 * @Description: CTA section - Ready to Create Your First AI Avatar Video
 */
import React from 'react';

import StartButton from './StartButton';

const CTASection: React.FC = () => {
  return (
    <section className="w-full bg-[#0A0A0A] py-[80px] pad:py-[100px] sm:py-[120px] px-4 pad:px-8 sm:px-[65px]">
      <div className="max-w-[1190px] mx-auto text-center">
        {/* Title */}
        <h2 className="text-2xl pad:text-3xl sm:text-[42px] font-bold text-white mb-4 pad:mb-6 leading-tight">
          Ready to Create Your First AI Avatar Video?
        </h2>

        {/* Description */}
        <p className="text-sm pad:text-base sm:text-base text-gray-400 max-w-4xl mx-auto mb-8 pad:mb-10 sm:mb-12 leading-relaxed">
          Turn scripts into studio-quality videos—no camera, no actors, no editing.
          FalcoCut combines AI avatars, voice cloning, lip sync, and multilingual video
          translation so you can launch marketing, training, and e-commerce content in
          minutes.
        </p>

        {/* CTA Button */}
        <StartButton text="Create Your AI Avatar Video" />
      </div>
    </section>
  );
};

export default CTASection;
